/* ===========================================================================
   b2c-event-planer.js Vollbild-Event-Planer (Planer-V2-Welle)
   Stand: 03.08.2026 · Builder: b2c-designer · Status: KANDIDAT (nicht deployt)

   GRUNDSATZ
     Die Stueckelung ist eine ZUTAT, kein Traeger. Ohne dieses Script stehen
     alle Schritte untereinander, alle Felder sind bedienbar und ein normaler
     Submit geht an denselben Shopify-Endpunkt. Deshalb wird .is-stepped erst
     hier gesetzt und alles JS-Abhaengige (Slider, Live-Preis, Vorschau,
     Zusammenfassung) ist per CSS nur unter .is-stepped sichtbar.

   PREIS
     Einzige Wahrheit ist die Registry-Staffel (129/109/99/89/79, ab 251
     individuell) identisch zum Collection-Rechner. Die Design-Quelle liess
     den Zaehler bis 400 laufen; das ist hier bewusst NICHT uebernommen.

   PLANER-V2 (03.08.2026, Owner-Auftrag)
     Der Mini-Artwork-Schritt ist ersatzlos entfallen - Wizard 7 -> 6 Schritte.
     Canvas-Markup, Canvas-CSS und der komplette Sprueh-Block in dieser Datei
     sind entfernt, nicht auskommentiert: toter Code laedt zum Wiederbeleben
     ein und laesst spaeter offen, was Absicht war.
     Neu an dieser Stelle: die Format-Vorschau traegt jetzt echte Fotos aus
     dem Live-Produktbestand und einen Registry-gedeckten Erklaersatz.
   =========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-b2c-ep]');
  if (!root) { return; }

  /* Nach Erfolg rendert Liquid gar keine Eingabe mehr dann gibt es nichts
     zu stueckeln, nur die Meldung anzusteuern. */
  var msg = root.querySelector('.b2c-ep-msg');
  function gotoMsg() {
    if (!msg) { return; }
    try { msg.focus({ preventScroll: true }); } catch (e) {}
    try { msg.scrollIntoView({ block: 'center' }); } catch (e) {}
  }

  var form = root.querySelector('.b2c-ep-form');
  var steps = [].slice.call(root.querySelectorAll('[data-ep-step]'));
  /* PLANER-V2, Reihenfolge-Fix: Hier stand der fruehe Ausstieg fuer den
     Erfolgsfall (nach Erfolg rendert Liquid keine Schritte mehr). Genau
     deshalb lief auf der Erfolgsseite NICHTS mehr - auch die Quittung nicht.
     Der Ausstieg steht jetzt unter dem Speicher-Block, damit der Erfolgsfall
     seine eigene Behandlung bekommt, bevor das Script sich verabschiedet. */


  /* ---- Sprache ----------------------------------------------------------
     T-EN-PLANER-JS (06.08.2026). Die Liquid-Section hat seit der EN-Welle
     eine request.locale-Weiche, die JS-erzeugten Texte hatten keine - im
     englischen Wizard standen deshalb Schrittzaehler, Preisblock,
     Format-Vorschau und Zusammenfassung weiter auf Deutsch.
     EINE Quelle fuer die Sprache: das Attribut data-ep-lang, das die Section
     aus request.locale.iso_code rendert. Kein Raten am URL-Pfad, kein
     zweites Locale-Signal. Faellt das Attribut aus, bleibt es bei Deutsch -
     das ist der Zustand von vor dieser Aenderung.
     Die ANZEIGE-Namen der Formate und Ortsarten stehen bewusst NICHT hier:
     die rendert Liquid bereits lokalisiert ins Markup (ep_names_display /
     ep_places_display), waehrend der abgeschickte Wert deutsch bleibt.
     Eine Kopie dieser Namen im JS waere die zweite Wahrheit - sie werden
     stattdessen aus dem DOM gelesen (labelOf weiter unten). */
  var EP_LANG = (root.getAttribute('data-ep-lang') || 'de').toLowerCase().indexOf('en') === 0 ? 'en' : 'de';
  /* Diese vier Zeichen sind Zeichen fuer Zeichen aus dem bisherigen Stand
     uebernommen (Mittelpunkt, Euro, Auslassungspunkte, Geviertstrich) - sie
     werden im Bau-Schritt aus der Quelldatei gelesen, nie abgetippt (F-058).
     Als eigene Konstanten stehen sie beiden Sprachzweigen zur Verfuegung. */
  var SEP = '·', EUR = '€', ELL = '…';
  var I18N = {
    de: {
      locale: 'de-DE',
      stepOf: function (n, total) { return 'Schritt ' + n + ' von ' + total; },
      stepRe: /(Schritt\s*\d+\s*von\s*\d+|Step\s*\d+\s*of\s*\d+)/g,
      start: 'Start',
      sending: 'Wird gesendet ' + ELL,
      minPrefix: 'min. ',
      perPersonNet: 'Pro Person ' + SEP + ' netto',
      perPerson: 'Pro Person',
      priceOpen: 'noch offen',
      pickFormat: 'Wählt zuerst ein Format, dann steht hier euer Preis.',
      noteStaffel: 'inkl. Material, Anleitung und Aufbau ' + SEP + ' zzgl. 19 % MwSt.',
      noteOther: 'zzgl. 19 % MwSt.',
      individual: 'individuell',
      over250: 'Ab 251 Personen machen wir euch ein eigenes Angebot.',
      totalLabel: 'Gesamt inkl. MwSt.',
      money: function (n) { return n + ' ' + EUR; },
      from35: 'ab 35 ' + EUR,
      from35Net: 'ab 35 ' + EUR + ' netto',
      netSuffix: ' netto',
      tourNote: 'Den genauen Preis nennen wir euch mit dem Vorschlag.',
      customNote: 'Für dieses Format machen wir euch ein eigenes Angebot.',
      people: function (n) { return n + ' Personen'; },
      morePeople: 'mehr als 250 Personen',
      more250: 'mehr als 250',
      date: function (iso) { return iso.split('-').reverse().join('.'); },
      sum: { name: 'Name', format: 'Format', size: 'Teamgröße', per: 'Preis pro Person',
             total: 'Gesamt inkl. MwSt.', place: 'Ort', date: 'Termin',
             contact: 'Kontakt', company: 'Firma', message: 'Was ihr vorhabt' },
      recap: { format: 'Format', people: 'Personen', place: 'Ort', date: 'Termin' }
    },
    en: {
      locale: 'en-GB',
      stepOf: function (n, total) { return 'Step ' + n + ' of ' + total; },
      stepRe: /(Schritt\s*\d+\s*von\s*\d+|Step\s*\d+\s*of\s*\d+)/g,
      start: 'Start',
      sending: 'Sending ' + ELL,
      minPrefix: 'min. ',
      perPersonNet: 'Per person ' + SEP + ' net',
      perPerson: 'Per person',
      priceOpen: 'not set yet',
      pickFormat: 'Pick a format first, then your price shows up here.',
      noteStaffel: 'incl. materials, guidance and setup ' + SEP + ' plus 19 % VAT',
      noteOther: 'plus 19 % VAT',
      individual: 'individual',
      over250: 'From 251 people we put together your own offer.',
      totalLabel: 'Total incl. VAT',
      money: function (n) { return EUR + n; },
      from35: 'from ' + EUR + '35',
      from35Net: 'from ' + EUR + '35 net',
      netSuffix: ' net',
      tourNote: 'We will name the exact price with the proposal.',
      customNote: 'For this format we put together your own offer.',
      people: function (n) { return n + ' people'; },
      morePeople: 'more than 250 people',
      more250: 'more than 250',
      /* Bewusst 5 Aug 2026 statt 05.08.2026: ein englischsprachiger Leser
         liest 05.08. je nach Herkunft als 5. August ODER als 8. Mai. Bei
         einem Wunschtermin ist das keine Kosmetik. Der abgeschickte Wert
         bleibt unveraendert das ISO-Datum aus dem date-Feld. */
      date: function (iso) {
        var M = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        var p = iso.split('-');
        return parseInt(p[2], 10) + ' ' + (M[parseInt(p[1], 10) - 1] || p[1]) + ' ' + p[0];
      },
      sum: { name: 'Name', format: 'Format', size: 'Team size', per: 'Price per person',
             total: 'Total incl. VAT', place: 'Location', date: 'Date',
             contact: 'Contact', company: 'Company', message: 'What you have in mind' },
      recap: { format: 'Format', people: 'People', place: 'Location', date: 'Date' }
    }
  };
  var T = I18N[EP_LANG];

  /* Der ANZEIGE-Text eines angekreuzten Radios, so wie Liquid ihn lokalisiert
     gerendert hat. Der Wert (el.value) bleibt davon unberuehrt und geht
     weiterhin deutsch an die Anfrage-Mail - genau wie es die EN-Welle
     festgelegt hat. Faellt das Label aus, gilt der Wert. */
  function labelOf(el) {
    if (!el) { return ''; }
    var lab = el.parentNode;
    while (lab && lab.tagName !== 'LABEL') { lab = lab.parentNode; }
    if (!lab) { return el.value; }
    var b = lab.querySelector('b');
    var t = (b ? b.textContent : lab.textContent) || '';
    t = t.replace(/\s+/g, ' ').trim();
    return t || el.value;
  }

  var bar = root.querySelector('[data-ep-bar]');
  var live = root.querySelector('[data-ep-live]');
  var navLabel = root.querySelector('[data-ep-navlabel]');
  var btnBack = root.querySelector('[data-ep-back]');
  var btnNext = root.querySelector('[data-ep-next]');
  var btnSubmit = root.querySelector('[data-ep-submit]');
  var btnStart = root.querySelector('[data-ep-start]');
  var i = 0;

  /* ---- Eingaben ueberleben den Fehlerpfad -------------------------------
     Shopify gibt beim contact-Formular NUR die E-Mail zurueck (form.email).
     Fuer alle anderen Felder existiert keine Liquid-Persistenz. Ohne diese
     Kruecke haette ein Tippfehler in der Mail sieben Schritte vernichtet.
     Grenze offen: sessionStorage endet mit dem Tab. */
  var STORE = 'b2c-ep:' + (root.id || 'default');

  function namedFields() {
    return [].slice.call(root.querySelectorAll('[name]')).filter(function (f) {
      return f.type !== 'hidden';
    });
  }
  function save() {
    try {
      var data = {};
      namedFields().forEach(function (f) {
        if (f.type === 'radio') { if (f.checked) { data[f.name] = f.value; } }
        else if (f.value) { data[f.name] = f.value; }
      });
      sessionStorage.setItem(STORE, JSON.stringify(data));
    } catch (e) {}
  }
  function restore() {
    try {
      var raw = sessionStorage.getItem(STORE);
      if (!raw) { return; }
      var data = JSON.parse(raw);
      namedFields().forEach(function (f) {
        if (!data[f.name]) { return; }
        if (f.type === 'radio') { f.checked = (f.value === data[f.name]); return; }
        /* Die Mail kommt als echte Server-Rueckgabe zurueck und darf nicht von
           einem aelteren Zwischenstand ueberschrieben werden. Alle anderen
           Vorbelegungen sind Vermutungen die Eingabe gewinnt. */
        if (f.type === 'email' && f.value) { return; }
        f.value = data[f.name];
        if (f.tagName === 'SELECT' && f.value !== data[f.name]) { f.value = ''; }
      });
    } catch (e) {}
  }
  function clearStore() { try { sessionStorage.removeItem(STORE); } catch (e) {} }

  /* PLANER-V2: Die Sende-Marke wird NUR beim tatsaechlichen Absenden gesetzt.
     Sie ist die Bedingung dafuer, dass die Erfolgskarte spaeter ueberhaupt
     Werte zeigt - ein liegengebliebener Entwurf hat keine und erzeugt damit
     auch keine falsche Quittung. */
  var SENT = STORE + ':sent';
  function markSent() { try { sessionStorage.setItem(SENT, '1'); } catch (e) {} }
  function tookSent() {
    try {
      var v = sessionStorage.getItem(SENT);
      sessionStorage.removeItem(SENT);
      return v === '1';
    } catch (e) { return false; }
  }

  /* Quittung auf der Erfolgskarte: kurze Chips aus genau den Feldern, die der
     Nutzer selbst ausgefuellt hat. Kein Preis (K-E-Gate), keine abgeleiteten
     Aussagen - nur Wiedergabe. */
  function paintRecap() {
    var box = root.querySelector('[data-ep-recap]');
    if (!box || !tookSent()) { return; }
    var data;
    try { data = JSON.parse(sessionStorage.getItem(STORE) || 'null'); } catch (e) { data = null; }
    if (!data) { return; }
    [['contact[Workshop]', T.recap.format],
     ['contact[Personen]', T.recap.people],
     ['contact[Stadt]', T.recap.place],
     ['contact[Wunschtermin]', T.recap.date]
    ].forEach(function (pair) {
      var v = data[pair[0]];
      if (!v) { return; }
      if (pair[0] === 'contact[Wunschtermin]' && /^\d{4}-\d{2}-\d{2}$/.test(v)) {
        v = T.date(v);
      }
      /* 251 ist im Regler die Obergrenze und steht fuer "mehr als 250" -
         als blanke Zahl waere sie eine Angabe, die so niemand gemacht hat. */
      if (pair[0] === 'contact[Personen]' && String(v) === '251') { v = T.more250; }
      var wrap = document.createElement('div');
      var dt = document.createElement('dt');
      var dd = document.createElement('dd');
      dt.textContent = pair[1];
      dd.textContent = v;
      wrap.appendChild(dt); wrap.appendChild(dd);
      box.appendChild(wrap);
    });
  }

  var msgIsError = !!(msg && msg.classList.contains('b2c-ep-msg--err'));
  /* Reihenfolge zaehlt: erst die Quittung aus dem Stand zeichnen, dann den
     Stand loeschen. Umgekehrt stuende die Karte leer da. */
  if (msg && !msgIsError) { paintRecap(); clearStore(); }

  /* Ab hier geht es nur noch um den Wizard. Gibt es keine Schritte (Erfolg)
     oder kein Formular, ist die Arbeit getan - Meldung ansteuern, fertig. */
  if (!form || steps.length < 2) { gotoMsg(); return; }

  /* .is-stepped erst HIER: die Klasse behauptet "es wird gestueckelt". Auf der
     Erfolgsseite gibt es nichts zu stueckeln, dort waere sie eine Luege im
     DOM - und Luegen im DOM werden irgendwann von CSS geglaubt. */
  root.classList.add('is-stepped');
  /* Perf-Welle P4: Lebenszeichen fuer das Zeitnetz im Inline-Skript.
     Ohne diese Zeile nimmt die Seite nach 4 s die Vorweg-Ausblendung
     zurueck - genau das soll sie ja, wenn dieses Skript NICHT laeuft. */
  document.documentElement.classList.add('b2cep-ready');

  if (msgIsError) { restore(); }

  /* ---- Schrittwechsel --------------------------------------------------- */
  /* ---- Schritt-Tracking (Lead-Register-Welle 03.08.2026) -----------------
     Owner-Frage: "wo brechen sie ab?". Ohne diese Events ist der Planer eine
     Blackbox zwischen Aufruf und Anfrage.

     Zaehlung 0-6, NICHT 1-6: steps[0] ist der Intro-Schritt (data-ep-intro),
     die Datei rechnet selbst total = steps.length - 1 ("Der Intro-Schritt ist
     kein Schritt"). Der Intro feuert deshalb planer_start und KEIN
     planer_step_view damit step_nummer deckungsgleich ist mit dem, was der
     Nutzer als "Schritt 3 von 6" liest.

     ausloeser: 'nutzer' bei Weiter/Zurueck/Enter, 'system' beim
     programmatischen Ruecksprung im Submit-Fehlerfall. Das Event wird nicht
     unterdrueckt, nur unterscheidbar gemacht.

     is_first_view: GA4 dedupt nicht, jeder View zaehlt. Ohne dieses Flag
     waere der Funnel Schritt 1 -> Schritt 6 falsch, sobald jemand
     zuruecknavigiert (Schritt 2 zaehlte oefter als Schritt 1, die
     Abbruchquote saehe besser aus als sie ist). Mit dem Flag liefern
     DIESELBEN Events beide Wahrheiten: rohe Views fuers Zaudern,
     is_first_view=true fuer den echten Abbruch-Funnel.

     KEINE PII: nur Schrittnummer, Schrittname und die zwei Flags. */
  /* form_location kommt NICHT aus einer JS-Konstante, sondern aus dem
     Hidden-Feld, das Liquid ohnehin rendert (contact[Formular-Ort],
     Section-Setting). Damit gibt es genau einen Ort, an dem der Wert steht -
     Mail und Event koennen nicht auseinanderlaufen. */
  var EP_LOC = (function () {
    var el = root.querySelector('input[type=hidden][name="contact[Formular-Ort]"]');
    return (el && el.value) ? el.value : 'event-planer';
  })();
  var TRACK_MAX = 'b2c_ep_max_step';
  var startFired = false;

  function stepName(el, n) {
    var lg = el && el.querySelector('.b2c-ep-legend');
    var t = lg ? (lg.textContent || '') : '';
    /* Die Legende enthaelt die Zaehlzeile ("Schritt 2 von 6") als eigenes
       Kind. Die wird entfernt, sonst steht die Nummer doppelt im Namen. */
    t = t.replace(T.stepRe, '');
    t = t.replace(/\s+/g, ' ').trim();
    return t || T.stepOf(n, 0);
  }

  function maxSeen() {
    try { return parseInt(sessionStorage.getItem(TRACK_MAX) || '0', 10) || 0; }
    catch (e) { return 0; }
  }
  function noteSeen(n) {
    try { if (n > maxSeen()) { sessionStorage.setItem(TRACK_MAX, String(n)); } } catch (e) {}
  }

  function trackStep(n, el, announce) {
    var dl = (window.dataLayer = window.dataLayer || []);
    if (n === 0) { return; }
    if (!startFired) {
      startFired = true;
      dl.push({ event: 'planer_start', form_location: EP_LOC });
    }
    var first = n > maxSeen();
    noteSeen(n);
    dl.push({
      event: 'planer_step_view',
      form_location: EP_LOC,
      step_nummer: n,
      step_name: stepName(el, n),
      ausloeser: announce ? 'nutzer' : 'system',
      is_first_view: first
    });
  }

  function show(n, announce) {
    i = Math.max(0, Math.min(steps.length - 1, n));
    trackStep(i, steps[i], !!announce);
    steps.forEach(function (s, k) {
      if (k === i) { s.setAttribute('data-active', ''); }
      else { s.removeAttribute('data-active'); }
    });

    root.toggleAttribute('data-first', i === 0);
    root.toggleAttribute('data-last', i === steps.length - 1);
    root.toggleAttribute('data-intro', steps[i].hasAttribute('data-ep-intro'));

    var total = steps.length - 1; /* Der Intro-Schritt ist kein Schritt. */
    var label = i === 0 ? '' : T.stepOf(i, total);
    if (bar) { bar.style.width = (i / total * 100) + '%'; }
    if (navLabel) { navLabel.textContent = label; }
    if (announce && live) { live.textContent = label || T.start; }

    if (i === steps.length - 1) { renderSummary(); }

    if (announce) {
      var first = steps[i].querySelector('input:not([type=hidden]):not([type=range]), select, button');
      if (first) { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }
    }
  }

  /* Nur die Felder des SICHTBAREN Schritts pruefen checkValidity() auf dem
     ganzen Formular wuerde ueber Pflichtfelder stolpern, die der Nutzer noch
     gar nicht gesehen hat. */
  function stepValid() {
    var fields = [].slice.call(steps[i].querySelectorAll('input, select'));
    var ok = true;
    var seenGroup = {};
    fields.forEach(function (f) {
      if (f.type === 'range') { return; }
      var good = !f.checkValidity || f.checkValidity();
      if (f.type === 'radio') {
        if (seenGroup[f.name]) { return; }
        seenGroup[f.name] = true;
        good = !f.required || !!steps[i].querySelector('input[name="' + f.name + '"]:checked');
      }
      var box = f.type === 'radio'
        ? steps[i].querySelector('[data-ep-err-for="' + f.name + '"]')
        : (f.getAttribute('aria-describedby') ? document.getElementById(f.getAttribute('aria-describedby')) : null);
      if (good) {
        f.removeAttribute('aria-invalid');
        if (box) { box.removeAttribute('data-shown'); }
      } else {
        f.setAttribute('aria-invalid', 'true');
        if (box) { box.setAttribute('data-shown', ''); }
        if (ok) { try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } }
        ok = false;
      }
    });
    return ok;
  }

  if (btnNext) { btnNext.addEventListener('click', function () { if (stepValid()) { show(i + 1, true); } }); }
  if (btnStart) { btnStart.addEventListener('click', function () { show(1, true); }); }
  if (btnBack) { btnBack.addEventListener('click', function () { show(i - 1, true); }); }

  /* Enter geht weiter statt abzusenden bis auf den letzten Schritt. */
  form.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') { return; }
    if (i === steps.length - 1) { return; }
    e.preventDefault();
    if (stepValid()) { show(i + 1, true); }
  });

  if (btnSubmit) {
    form.addEventListener('submit', function (e) {
      if (!stepValid()) { e.preventDefault(); return; }
      save();
      markSent();
      btnSubmit.disabled = true;
      btnSubmit.textContent = T.sending;
    });
  }

  /* ---- Anrede ----------------------------------------------------------- */
  var nameEl = root.querySelector('[data-ep-name]');
  var greets = [].slice.call(root.querySelectorAll('[data-ep-greet]'));
  function paintGreeting() {
    var v = nameEl && nameEl.value ? nameEl.value.trim() : '';
    greets.forEach(function (g) { g.textContent = v ? ('Hi ' + v + '! ') : ''; });
  }
  if (nameEl) { nameEl.addEventListener('input', paintGreeting); }

  /* ---- Format-Vorschau --------------------------------------------------
     Text statt Fotostrecke: die Design-Quelle zog Bilder aus einem
     Handoff-Ordner, der im Theme nicht existiert. Ein Platzhalter-Bild waere
     eine Behauptung; die Punkte sind belegte Leistungsbestandteile. */
  /* PLANER-V2 Bildquellen: ausschliesslich Produktbilder aus dem LIVE-Bestand,
     am 03.08.2026 per Admin-API (productByHandle -> media) gesichtet - UND
     danach einzeln ANGESEHEN. Das war noetig: die Dateinamen dieses Shops
     beschreiben den Bildinhalt teilweise falsch (die Datei
     "Team_arbeitet_parallel_an_mehreren_Wandsegmenten..." zeigt eine einzelne
     Person an einem Bus, "...group-walking" zeigt eine leere Hauswand). Alt-
     Texte und Format-Zuordnung stammen deshalb aus der Sichtung, nicht aus
     dem Dateinamen.
     Je Bild ist die kleinste Originalkante notiert; der Anzeige-Slot ist
     112 px hoch, die Reserve gegen F-021 ist damit gross. ?width=440 deckt
     den Slot auch auf 2x-Displays.

     Der Satz in f ist der eine zusaetzliche Erklaersatz (Dauer/Gruppe/
     Ergebnis) und stammt aus freigegebenen Registry-Zeilen:
       Dauer 2-3 Stunden fuer Workshops · Graffiti 10-1.000 / Action Painting
       15-500 Personen · Graffiti an der Wand immer outdoor, Action Painting
       indoor UND outdoor · Mindestanzahl 10 · individuelles Angebot fuer
       Kombi/Mehrtaegig (keine belegte Staffel).
     Preise stehen hier bewusst NICHT (K-E-Gate). */
  var IMG = 'https://cdn.shopify.com/s/files/1/0815/1964/0910/files/';
  var W = '?width=440';
  var PREVIEW = {
    action: {
      t: 'Action Painting',
      p: ['Leinwand, Stifte, Schwämme und Spritzpistolen', 'Styles à la Pollock und Basquiat', 'Ergebnis zum Mitnehmen — Werk oder Drohnen-Foto.'],
      f: 'Zwei bis drei Stunden, 15 bis 500 Personen, drinnen wie draußen.',
      img: [
        /* 800x1200 · gesichtet: zwei Personen in Maleroveralls vor einer
           grossen Leinwand, Krone/Dollarzeichen im Basquiat-Duktus, indoor. */
        [IMG + 'ActionPaintingDetailaufnahme_HaendeundFarbebeimTeambuildingEvent.webp' + W,
         'Zwei Teilnehmende in Maleroveralls arbeiten an einer grossen, bunt bemalten Leinwand'],
        /* 1183x648 · gesichtet: Briefing-Szene, Brain2Canvas-Shirt im
           Vordergrund, Teilnehmende in Overalls und Handschuhen, Dosen. */
        [IMG + 'ActionPaintingTeambuildingEvent_FarbeinBewegungbeieinemkreativenFirmenevent.webp' + W,
         'Briefing vor dem Start: Teilnehmende in Overalls und Handschuhen am Materialtisch']
      ]
    },
    graffiti: {
      t: 'Graffiti Workshop',
      p: ['Großes Team-Piece an legaler Wand', 'Profi-Writer leiten euch an', 'Drohnen-Foto inklusive'],
      f: 'Zwei bis drei Stunden, 10 bis 1.000 Personen, an der Wand immer draußen.',
      /* Bewusst nur EIN Foto (der Auftrag laesst 1-2 zu). Die uebrigen Bilder
         des Graffiti-Produkts zeigen bei eigener Sichtung durchweg das
         Paint-the-Bus-Format - ein Bus unter der Ueberschrift "Team-Piece an
         legaler Wand" waere ein Bild, das dem Text widerspricht.
         Owner-Nachtrag 03.08. (Planer-V2-Welle): das vorige Bild zeigte
         sichtbar den Schriftzug "CREATIVE MINDS BERLIN" auf der Wand -
         stadtfremd fuer diesen Kontext. Ersetzt durch ein muenchen-belegtes
         Bild (Cloudflare-Case, Bahnwaerter Thiel, gesichtet per Shopify
         Files-API + Playwright-Screenshot). */
      img: [
        /* 4032x2268 · gesichtet: Drohnen-/Weitwinkelaufnahme, Team steht an
           einer legalen Wand am Bahnwaerter Thiel in Muenchen vor einem
           fertigen Piece (Cloudflare-Case), outdoor. */
        [IMG + 'cloudflare-graffiti-teamevent-bahnwaerter-thiel-muenchen-1.jpg' + W,
         'Team steht gemeinsam vor einem fertigen Graffiti-Piece an einer legalen Wand am Bahnwärter Thiel in München']
      ]
    },
    tour: {
      t: 'Street Art Tour mit Guide',
      p: ['Durch die Stadt als Galerie', 'Murals, versteckte Spots und ihre Geschichten', 'Passt als Auftakt oder als Pause'],
      f: 'Ab 10 Personen, app-geführt im eigenen Tempo.',
      img: [
        /* 3584x4800 · gesichtet: Gruppe laeuft an einer bemalten Backsteinwand
           entlang, Strassenschild Oranienstrasse, Kopfsteinpflaster. */
        [IMG + 'team-building-street-art-urban-art.webp' + W,
         'Gruppe geht an einer bemalten Backsteinfassade entlang und betrachtet das Motiv'],
        /* 2268x4032 · gesichtet: grosse Hauswand-Mural mit silbernen
           Ballon-Buchstaben ueber einer Schwarzweiss-Zeichnung. */
        [IMG + 'street-art-tour-team-event-group-walking.webp' + W,
         'Großflächiges Wandbild mit silbernen Ballon-Buchstaben an einer Hausfassade']
      ]
    },
    kombi: {
      t: 'Graffiti + Tour',
      p: ['Erst die Szene entdecken …', '… dann selbst ans Werk', 'Ein voller Tag, ein Erlebnis'],
      f: 'Ab 10 Personen; der Graffiti-Teil dauert zwei bis drei Stunden.',
      /* Reihenfolge folgt dem Text darunter: erst entdecken, dann sprühen. */
      img: [
        /* 4032x2268 · gesichtet: zwei Personen fotografieren ein grosses
           Graffiti-Piece mit dem Handy. */
        [IMG + 'brain2canvas-team-building-default-title-graffiti-workshop-streetart-tour-in-frankfurt-kreatives-team-event-in-frankfurt-59767740236110.jpg' + W,
         'Zwei Teilnehmende fotografieren ein großes Graffiti-Piece während der Tour'],
        /* 4000x6000 · gesichtet: behandschuhte Hand mit Spraydose vor einem
           frisch besprühten Waggon. */
        [IMG + 'brain2canvas-team-building-default-title-graffiti-workshop-streetart-tour-in-frankfurt-kreatives-team-event-in-frankfurt-59767732601166.jpg' + W,
         'Behandschuhte Hand mit Spraydose vor der frisch gesprühten Fläche']
      ]
    },
    mehr: {
      t: 'Mehrtägig',
      p: ['Über mehrere Tage gedacht', 'Ideen-Sprint mit Pausen', 'Für Offsites und Konferenzen'],
      f: 'Ab 10 Personen, individuelles Angebot.',
      /* Kein eigenes Produkt im Live-Bestand -> kein Foto. Ein geliehenes
         waere eine Behauptung ueber ein Format, das es so nicht zeigt. */
      img: []
    }
  };


  /* Englische Fassung der Vorschau. NUR Text - Bild-URLs, Reihenfolge und
     Struktur kommen unveraendert aus PREVIEW oben (eine Quelle). Die
     Teilnehmerzahlen sind die der Facts Registry, nicht neu gerechnet. */
  var PREVIEW_EN = {
    action: {
      t: 'Action Painting',
      p: ['Canvas, markers, sponges and spray guns', 'Styles in the vein of Pollock and Basquiat', 'The result is yours to keep — the piece or a drone shot.'],
      f: 'Two to three hours, 15 to 500 people, indoors and out.',
      alt: ['Two participants in painter overalls working on a large, colourfully painted canvas',
            'Briefing before the start: participants in overalls and gloves at the materials table']
    },
    graffiti: {
      t: 'Graffiti Workshop',
      p: ['One big team piece on a legal wall', 'Pro writers guide you', 'Drone photo included'],
      f: 'Two to three hours, 10 to 1,000 people, always outdoors at the wall.',
      alt: ['Team standing together in front of a finished graffiti piece on a legal wall at Bahnwärter Thiel in Munich']
    },
    tour: {
      t: 'Street Art Tour with Guide',
      p: ['The city as your gallery', 'Murals, hidden spots and the stories behind them', 'Works as an opener or as a break'],
      f: 'From 10 people, app-guided at your own pace.',
      alt: ['Group walking along a painted brick facade, looking at the artwork',
            'Large wall mural with silver balloon letters on a house facade']
    },
    kombi: {
      t: 'Graffiti + Tour',
      p: ['First discover the scene …', '… then get to work yourselves', 'One full day, one experience'],
      f: 'From 10 people; the graffiti part runs two to three hours.',
      alt: ['Two participants photographing a large graffiti piece during the tour',
            'Gloved hand holding a spray can in front of the freshly sprayed surface']
    },
    mehr: {
      t: 'Multi-Day',
      p: ['Spread across several days', 'Idea sprint with breaks', 'For offsites and conferences'],
      f: 'From 10 people, individual quote.',
      alt: []
    }
  };
  if (EP_LANG === 'en') {
    Object.keys(PREVIEW_EN).forEach(function (k) {
      var en = PREVIEW_EN[k], de = PREVIEW[k];
      if (!de) { return; }
      de.t = en.t; de.p = en.p; de.f = en.f;
      (de.img || []).forEach(function (shot, ix) {
        if (en.alt[ix]) { shot[1] = en.alt[ix]; }
      });
    });
  }

  var pvEmpty = root.querySelector('[data-ep-preview-empty]');
  var pvCard = root.querySelector('[data-ep-preview-card]');
  var pvTitle = root.querySelector('[data-ep-preview-title]');
  var pvList = root.querySelector('[data-ep-preview-list]');
  var pvFact = root.querySelector('[data-ep-preview-fact]');
  var pvShots = root.querySelector('[data-ep-shots]');
  [].slice.call(root.querySelectorAll('[data-ep-ws]')).forEach(function (r) {
    r.addEventListener('change', function () {
      var d = PREVIEW[r.getAttribute('data-ep-ws')];
      if (!d || !pvCard) { return; }
      pvTitle.textContent = d.t;
      pvList.innerHTML = '';
      d.p.forEach(function (line) {
        var li = document.createElement('li');
        li.textContent = line;
        pvList.appendChild(li);
      });
      if (pvFact) { pvFact.textContent = d.f || ''; }
      if (pvShots) {
        /* Neu aufbauen statt src umbiegen: sonst zeigt der Stapel beim
           Formatwechsel kurz das alte Foto unter der neuen Ueberschrift. */
        pvShots.innerHTML = '';
        (d.img || []).forEach(function (shot) {
          var span = document.createElement('span');
          var im = document.createElement('img');
          im.src = shot[0];
          im.alt = shot[1];
          /* Der Slot ist per CSS fest, width/height halten das Seiten-
             verhaeltnis fuer den Browser trotzdem plausibel (kein CLS). */
          im.width = 440; im.height = 248;
          im.loading = 'lazy'; im.decoding = 'async';
          span.appendChild(im);
          pvShots.appendChild(span);
        });
      }
      pvCard.hidden = false;
      if (pvEmpty) { pvEmpty.hidden = true; }
      /* FIX-1/FIX-3: Format bestimmt Preislogik UND Untergrenze - beides
         muss sofort nachziehen, nicht erst beim naechsten Tastendruck. */
      applyMin();
    });
  });

  /* ---- Teamgroesse + Preis (formatabhaengig, Registry-gedeckt) ----------
     Judge-Befund FIX-1 (blockierend): der Preis rechnete die Staffel fuer
     JEDES Format. Wer die Street-Art-Tour waehlte, sah "109 EUR" statt
     "ab 35 EUR" - eine dem Kunden gezeigte, um ein Mehrfaches falsche Zahl
     auf einem Lead-Formular (F-007).
     Registry-Deckung je Format:
       Graffiti Workshop / Action Painting -> Staffel 129/109/99/89/79
         (Registry Z.115, Preisstaffel freigegeben)
       Street Art Tour mit Guide -> ab 35 EUR p. P. (Registry Z.161,
         ausdruecklich "kein Aufpreis-Posten der AP-Staffel"). Dort existiert
         KEINE Staffel, also wird auch keine gerechnet und keine Gesamtsumme
         behauptet - nur der belegte Ab-Preis.
       Graffiti + Tour -> individuell. Der Judge nennt dieses Format nicht,
         aber es faellt unter dieselbe Regel: fuer die Kombination existiert
         keine freigegebene Zahl, und eine addierte waere geraten.
       Mehrtaegig -> individuell (keine belegte Zahl).
     Judge-Befund FIX-3: auch die Untergrenze haengt am Format (Registry Z.9/
     Z.10: Graffiti 10-1.000, Action Painting 15-500). Fuer Tour, Kombi und
     Mehrtaegig nennt die Registry keine Untergrenze - dort bleibt die
     allgemeine 10 stehen, statt eine zu erfinden. */
  var MAX = 251; /* 251 steht fuer mehr als 250 -> individuelles Angebot. */
  var FORMATS = {
    action:   { mode: 'staffel', min: 15 },
    graffiti: { mode: 'staffel', min: 10 },
    tour:     { mode: 'ab35',    min: 10 },
    kombi:    { mode: 'custom',  min: 10 },
    mehr:     { mode: 'custom',  min: 10 }
  };
  var numEl = root.querySelector('[data-ep-num]');
  var rangeEl = root.querySelector('[data-ep-range]');
  var priceV = root.querySelector('[data-ep-price-v]');
  var priceT = root.querySelector('[data-ep-price-t]');
  var priceK = root.querySelector('[data-ep-price-k]');
  var scaleMin = root.querySelector('[data-ep-scale-min]');
  var priceNote = root.querySelector('[data-ep-price-note]');

  function currentFormat() {
    var el = root.querySelector('[data-ep-ws]:checked');
    return (el && FORMATS[el.getAttribute('data-ep-ws')]) || null;
  }
  function minFor(fmt) { return fmt ? fmt.min : 10; }

  /* Lead-Register-Welle 03.08.2026: die Staffel steht ab jetzt AUSSCHLIESSLICH
     in assets/b2c-preis.js. Grund: sobald ein zweites Formular denselben Preis
     nennt (contact[Preis netto p.P.]), waeren zwei Kopien derselben Zahlenreihe
     im Umlauf - genau der Judge-Befund FIX-1.
     Fehlt das Asset, wird BEWUSST null zurueckgegeben: der Preisblock zeigt
     dann "noch offen". Eine lokale Ersatz-Staffel waere die zweite Wahrheit,
     die diese Aenderung gerade beseitigt - und eine falsche Zahl ist teurer
     als eine fehlende. */
  function staffelPrice(n) {
    return (window.B2CPreis && window.B2CPreis.staffelPrice)
      ? window.B2CPreis.staffelPrice(n)
      : null;
  }
  /* Liefert die zwei Zeilen des Preisblocks plus die Zeile fuer die
     Zusammenfassung - EINE Quelle, damit Schritt 3 und Schritt 7 nie
     auseinanderlaufen koennen. */
  function priceFor(n, fmt) {
    if (!fmt) { return null; }
    var INDIV = { v: T.individual, t: T.over250, per: T.individual, total: '' };
    if (n >= MAX) { return INDIV; }
    if (fmt.mode === 'staffel') {
      var p = staffelPrice(n);
      if (p === null) { return INDIV; }
      /* FIX 06.08.: die Gesamtsumme wird als eigenes Feld zurueckgegeben.
         Vorher schnitt die Zusammenfassung sie per Praefix-Vergleich aus dem
         Fliesstext heraus - das haette beim Uebersetzen still gebrochen. */
      var tot = T.money(Math.round(n * p * 1.19).toLocaleString(T.locale));
      return { v: T.money(p), t: T.totalLabel + ' ' + tot, per: T.money(p) + T.netSuffix, total: tot };
    }
    if (fmt.mode === 'ab35') {
      /* Bewusst KEINE Gesamtsumme: belegt ist nur der Ab-Preis. */
      return { v: T.from35, t: T.tourNote, per: T.from35Net, total: '' };
    }
    return { v: T.individual, t: T.customNote, per: T.individual, total: '' };
  }

  function clamp(n, fmt) {
    return Math.max(minFor(fmt || currentFormat()), Math.min(MAX, isNaN(n) ? 25 : n));
  }

  function paintPrice() {
    if (!numEl) { return; }
    var fmt = currentFormat();
    var n = clamp(parseInt(numEl.value, 10), fmt);
    var r = priceFor(n, fmt);
    if (priceK) { priceK.textContent = (fmt && fmt.mode === 'staffel') ? T.perPersonNet : T.perPerson; }
    if (priceV) { priceV.textContent = r ? r.v : T.priceOpen; }
    if (priceT) { priceT.textContent = r ? r.t : T.pickFormat; }
    if (priceNote) {
      priceNote.textContent = (fmt && fmt.mode === 'staffel')
        ? T.noteStaffel
        : T.noteOther;
    }
  }

  /* Das Minimum wandert mit dem Format: Action Painting startet bei 15. */
  function applyMin() {
    var fmt = currentFormat();
    var min = minFor(fmt);
    if (numEl) { numEl.min = min; }
    if (rangeEl) { rangeEl.min = min; }
    if (scaleMin) { scaleMin.textContent = T.minPrefix + min; }
    if (numEl && parseInt(numEl.value, 10) < min) { setSize(min); return; }
    paintPrice();
  }
  function setSize(n, from) {
    var v = clamp(n);
    if (numEl && from !== 'num') { numEl.value = v; }
    if (rangeEl && from !== 'range') { rangeEl.value = v; }
    paintPrice();
  }
  if (numEl) { numEl.addEventListener('input', function () { setSize(parseInt(numEl.value, 10), 'num'); }); }
  if (numEl) { numEl.addEventListener('blur', function () { setSize(parseInt(numEl.value, 10)); }); }
  if (rangeEl) { rangeEl.addEventListener('input', function () { setSize(parseInt(rangeEl.value, 10), 'range'); }); }
  var dec = root.querySelector('[data-ep-dec]');
  var inc = root.querySelector('[data-ep-inc]');
  if (dec) { dec.addEventListener('click', function () { setSize(clamp(parseInt(numEl.value, 10)) - 1); }); }
  if (inc) { inc.addEventListener('click', function () { setSize(clamp(parseInt(numEl.value, 10)) + 1); }); }

  /* ---- Zusammenfassung -------------------------------------------------- */
  var sumBox = root.querySelector('[data-ep-sum]');
  function val(sel) { var el = root.querySelector(sel); return el && el.value ? el.value.trim() : ''; }
  function checked(name) {
    var el = root.querySelector('input[name="' + name + '"]:checked');
    return el ? el.value : '';
  }
  /* Fuer die Zusammenfassung zaehlt der ANZEIGE-Text, nicht der Sendewert. */
  function checkedLabel(name) {
    return labelOf(root.querySelector('input[name="' + name + '"]:checked'));
  }
  function renderSummary() {
    if (!sumBox) { return; }
    var fmt = currentFormat();
    var n = clamp(parseInt(val('[data-ep-num]') || '25', 10), fmt);
    var r = priceFor(n, fmt);
    var span = root.querySelector('[data-ep-span]');
    var spanTxt = span && span.value ? span.selectedOptions[0].textContent : '';
    var date = val('[data-ep-date]');
    var rows = [
      [T.sum.name, val('[data-ep-name]')],
      [T.sum.format, checkedLabel('contact[Workshop]')],
      [T.sum.size, n >= MAX ? T.morePeople : T.people(n)],
      [T.sum.per, r ? r.per : ''],
      /* FIX-1: die Gesamtsumme steht NUR, wo sie belegt ist - bei der Tour
         und bei individuellen Formaten gibt es keine, also auch keine Zeile. */
      [T.sum.total, (r && r.total) ? r.total : ''],
      [T.sum.place, [val('[data-ep-city]'), checkedLabel('contact[Ort-Art]')].filter(Boolean).join(' · ')],
      [T.sum.date, date ? T.date(date) : spanTxt],
      [T.sum.contact, val('[data-ep-email]')],
      [T.sum.company, val('[data-ep-company]')],
      /* Owner-Order 06.08.: der Freitext aus dem neuen Schritt 6 erscheint
         als eigene Zeile. Leer = keine Zeile (der .filter unten wirft sie
         raus), damit keine leere Zeile in der Uebersicht steht. */
      [T.sum.message, val('[data-ep-message]'), 'b2c-ep-sum--text']
    ].filter(function (r) { return r[1]; });

    sumBox.innerHTML = '';
    rows.forEach(function (r) {
      var wrap = document.createElement('div');
      var dt = document.createElement('dt');
      var dd = document.createElement('dd');
      dt.textContent = r[0];
      dd.textContent = r[1];
      /* Dritter Eintrag = eigene Zeilenform. Nur der Freitext nutzt sie:
         Label oben, Text darunter linksbuendig ueber die volle Breite. */
      if (r[2]) { wrap.className = r[2]; }
      wrap.appendChild(dt); wrap.appendChild(dd);
      sumBox.appendChild(wrap);
    });
    sumBox.hidden = rows.length === 0;
  }

  /* Index des Schritts, in dem ein Feld liegt. -1, wenn es ihn nicht gibt.
     Bewusst ohne Element.closest, damit der Rest der Datei ES5 bleibt. */
  function stepIndexOf(sel) {
    var el = root.querySelector(sel);
    while (el && el !== root && !el.hasAttribute('data-ep-step')) { el = el.parentNode; }
    if (!el || el === root || !el.hasAttribute) { return -1; }
    return steps.indexOf(el);
  }

  /* ---- Start ------------------------------------------------------------ */
  paintGreeting();
  applyMin();
  show(0, false);

  if (msg) {
    /* FIX 06.08.: bis zur Textfeld-Welle stand hier steps.length - 2 mit
       dem Kommentar "zurueck aufs Kontaktfeld". Das stimmte nur, solange
       die Zusammenfassung direkt hinter dem Kontaktschritt lag. Seit der
       Freitext-Schritt dazwischen liegt, haette die Rechnung nach einem
       Formularfehler auf dem Freitext gelandet. Das Ziel wird jetzt ueber
       das Kontaktfeld selbst aufgeloest und haelt auch, wenn spaeter ein
       weiterer Schritt dazukommt. */
    if (msgIsError) {
      var ci = stepIndexOf('[data-ep-email]');
      show(ci >= 0 ? ci : steps.length - 1, false);
    }
    gotoMsg();
  }
})();
